export default __webpack_public_path__ + "static/media/rtg-3.5f4e13ae.svg";